import { MutationResponse, SuccessResponse, TermUnit } from "config";
import { gql } from "config/graphql";
import { getApolloClient } from "store/apollo";
import { assertDefined } from "utils/error";

interface AcceptProductOfferingInput {
  offeringId: string;
}

interface IAcceptProductOfferingData {
  acceptProductOffering: SuccessResponse;
}

export const acceptProductOfferingMutation: MutationResponse<
  AcceptProductOfferingInput,
  IAcceptProductOfferingData
> = async (input: AcceptProductOfferingInput) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation AcceptProductOffering($input: AcceptProductOfferingInput!) {
      acceptProductOffering(input: $input) {
        response {
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IAcceptProductOfferingData>({
    variables: {
      input,
    },
    mutation,
  });
  return { data: assertDefined(data) };
};

export interface IUpdateProductOfferingInput {
  offeringId: string;
  amount: number;
  termUnit?: TermUnit;
  termDuration?: number;
}

interface IUpdateProductOfferingData {
  updateProductOffering: SuccessResponse;
}

export const updateProductOfferingMutation: MutationResponse<
  IUpdateProductOfferingInput,
  IUpdateProductOfferingData
> = async (input: IUpdateProductOfferingInput) => {
  const client = getApolloClient();

  const mutation = gql`
    mutation updateProductOffering($input: UpdateProductOfferingInput!) {
      updateProductOffering(input: $input) {
        response {
          success
        }
      }
    }
  `;

  const { data } = await client.mutate<IUpdateProductOfferingData>({
    variables: {
      input,
    },
    mutation,
  });
  return { data: assertDefined(data) };
};
